export default __webpack_public_path__ + "static/media/no-results.0b97ad74.png";